/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListingSimulation } from '../models/ListingSimulation';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ListingSimulationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a ListingSimulation resource.
     * Retrieves a ListingSimulation resource.
     * @param listingType
     * @param listingId
     * @param pricePoint
     * @param adjustedAmortisationAbo
     * @param session
     * @param ctr
     * @param constOtaMultiplier
     * @param averageBasket
     * @returns ListingSimulation ListingSimulation resource
     * @throws ApiError
     */
    public apiAccommodationslistingsimulationGet(
        listingType?: string,
        listingId?: string,
        pricePoint?: number,
        adjustedAmortisationAbo?: number,
        session?: number,
        ctr?: number,
        constOtaMultiplier?: number,
        averageBasket?: number,
    ): CancelablePromise<ListingSimulation> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/listing/simulation',
            query: {
                listingType: listingType,
                listingId: listingId,
                pricePoint: pricePoint,
                adjustedAmortisationAbo: adjustedAmortisationAbo,
                session: session,
                ctr: ctr,
                constOtaMultiplier: constOtaMultiplier,
                averageBasket: averageBasket,
            },
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
